/*
 * @Author: caiqin.xie
 * @since: 2023-06-08 09:47:44
 * @lastTime: 2024-01-02 15:06:48
 * @LastEditors: caiqin.xie
 * @message: 博客详情
 * @url: www.picoxr.com/cn/blog/:seoUrl
 */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import styles from "./index.module.scss";
import Banner from "./components/Banner";
import TopTitle from "./components/TopTitle";
import ContentNav from "./components/ContentNav";
import AuthorInfo from "./components/AuthorInfo";
import RelatedArticles from "./components/RelatedArticles";
import RelatedGame from "./components/RelatedGame";
import Subscribe from "../components/Subscribe";
import RelatedNews from "./components/RelatedNews";
import { useDevice } from '@/hooks'
import request from '@/common/request'
import { DOMAIN_API, BLOGTYPE, BLOGDETAILPOS, COUNTRY_HREFLANG } from '@/common/const'
import { IBanner } from "@/common/types";
import classNames from "classnames";

const BlogDetail = (props: any) => {
  const {ctry, words, data} = props.data
  const device = useDevice()
  const [content, setContent] = useState(data) // 文章详情
  const bannerLists: IBanner[] = data?.bannerList || [] // banner

  // 渲染文章
  function creatHtml () {
    return {__html: content?.detail}
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      content && content.stationCodes && content.stationCodes.map((item: string) => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/blog/${content?.seoUrl}`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{content?.seoTitle ?? words?.blog_list_title}</title>
        <meta name="description" content={content?.seoDescription ?? words?.blog_list_description} />
        <meta name="keywords" content={content?.seoKeywords ?? words?.blog_list_keywords} />
        <link rel="canonical" href={content?.seoCanonical ?? ''} />
        {renderHrefLang()}
        <script type="application/ld+json">
          {content?.structuredCode}
        </script>
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['blog-wrap']}>
        {/* banner */}
        <Banner bannerLists={bannerLists}/>
        <div className={styles['blog-content-wrap']}>
          <article className={styles['blog-content']}>
            {/* 标题 */}
            <TopTitle title={content?.title} ctry={ctry} words={words} />

            <div className={styles['blog-bottom']}>
              {/* 左侧文章导航 PC端展示*/}
              <ContentNav ctry={ctry} words={words} regular={content?.regular} />

              <div className={styles['blog-article-wrap']}>
                {/* 文章封面 */}
                <div className={styles['blog-cover']}>
                  <img src={content?.cover?.url} alt={content?.cover?.alt} />
                </div>
                {/* 文章正文 */}
                <div className={classNames(styles['blog-article'], 'editor-wrap')} dangerouslySetInnerHTML={creatHtml()}></div>

                {/* 作者信息 */}
                <AuthorInfo authorDetailVO={content?.authorDetailVO} ctry={ctry} words={words} />

                {/* 相关推荐 */}
                <RelatedArticles
                  ctry={ctry}
                  words={words}
                  device={device}
                  title={content?.title}
                  relatedList={content?.correlationContents} />
              </div>
            </div>
          </article>
          {/* 右侧推荐 */}
          <div className={styles['blog-right']}>
            {/* 关联游戏 */}
            <RelatedGame ctry={ctry} words={words} gamesContent={content?.gamesContent} />

            {/* 订阅 */}
            <Subscribe
              ctry={ctry}
              words={words}
              className={styles['right-subscribe-wrap']}
              contentTypeId={BLOGTYPE}
              sourcePage='2'
              sourceUrl={`${DOMAIN_API}/blog/${content?.seoUrl}`}
            />

            {/* 最新blog */}
            <RelatedNews ctry={ctry} words={words} newsList={content?.newsContents} />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string, pathName: string) {
  return new Promise((resolve, reject) => {
    const decodedUrl = decodeURIComponent(pathName);
    const seoUrl = decodedUrl.split('?')[0].split('/').pop();
    request.get(`${DOMAIN_API}/o/content/detail?contentTypeId=${BLOGTYPE}&seoUrl=${seoUrl}&stationCode=${ctry}&bannerPositionId=${BLOGDETAILPOS}`)
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

BlogDetail.getInitialProps = (ctry: string, pathName: string) => {
  console.log(pathName)
  return getInit(ctry, pathName)
};
export default BlogDetail;
